/**
 * @flow
 * @relayHash 379aeb668e7e69247454654790cbd16c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type orgsTabQueryVariables = {|
  propertyId: string,
  type: string,
|};
export type orgsTabQueryResponse = {|
  +categories: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +type: string,
    +createdAt: any,
    +hasMore: boolean,
    +assets: $ReadOnlyArray<{|
      +id: string,
      +name: string,
      +fileUrl: string,
      +fileSize: number,
      +fileType: string,
      +thumbnailUrl: ?string,
      +createdAt: any,
    |}>,
  |}>
|};
export type orgsTabQuery = {|
  variables: orgsTabQueryVariables,
  response: orgsTabQueryResponse,
|};
*/


/*
query orgsTabQuery(
  $propertyId: ID!
  $type: String!
) {
  categories(propertyId: $propertyId, type: $type) {
    id
    name
    type
    createdAt
    hasMore
    assets {
      id
      name
      fileUrl
      fileSize
      fileType
      thumbnailUrl
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "categories",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "Category",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasMore",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "assets",
        "storageKey": null,
        "args": null,
        "concreteType": "Asset",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thumbnailUrl",
            "args": null,
            "storageKey": null
          },
          (v3/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "orgsTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "orgsTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "orgsTabQuery",
    "id": null,
    "text": "query orgsTabQuery(\n  $propertyId: ID!\n  $type: String!\n) {\n  categories(propertyId: $propertyId, type: $type) {\n    id\n    name\n    type\n    createdAt\n    hasMore\n    assets {\n      id\n      name\n      fileUrl\n      fileSize\n      fileType\n      thumbnailUrl\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd4d5e81d0bdbc568b78e8bac566c9787';
module.exports = node;
